import { BasketTransferError } from '@repo/ui/src/utils/errors';
import {
  GraphQLRequestWithTokenProps,
  rawRequestWithToken,
  DefaultVariables,
} from '@repo/ui/src/utils/graphql-request';
import { getShopTokens, setShopTokens } from '@utils/userTokens';

export const basketRequest = async <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>(
  props: GraphQLRequestWithTokenProps<Variables>,
) => {
  try {
    const { shopToken, basketJWT } = getShopTokens();
    const requestHeaders = new Headers(Object.entries(props.requestHeaders ?? {}));
    if (shopToken) {
      requestHeaders.set('x-shop-token', shopToken);
    }
    if (basketJWT) {
      requestHeaders.set('x-basket-token', basketJWT);
    }
    const { data, headers } =
      (await rawRequestWithToken<Data, Variables>({
        query: props.document,
        ...props,
        requestHeaders,
      } as any)) ?? {};

    setShopTokens({
      shopToken: headers?.get('x-shop-token'),
      basketJWT: headers?.get('x-basket-token'),
    });

    return data;
  } catch {
    throw new BasketTransferError();
  }
};

export class OutOfStockError extends Error {
  info;
  constructor(info: any) {
    super('Out of Stock');
    this.info = info;
  }
}
